import { regionCodes } from '../../referenceData';
import lookupWordByUid from '../lookupWordByUid';
import customGroupsService from '../../services/customGroupsService';

export default (state, location) => {
  // Check if this is a custom group
  const customGroup = customGroupsService.urlUtils.parseUrlParam(location);
  if (customGroup) {
    return customGroup.name;
  }

  if (regionCodes.includes(location)) {
    return lookupWordByUid(state, location);
  }

  return lookupWordByUid(state, `cnm${location}`);
};
